/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Field } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';

export const mergeDefaultValues = (
	defaultValuesFromAPI: Record<string, any> = {},
	defaultValuesFromFE: Field | undefined = {},
) => {
	const mergedDefaultValues = JSON.parse(JSON.stringify(defaultValuesFromAPI));
	if (!defaultValuesFromFE) return mergedDefaultValues;
	Object.keys(defaultValuesFromFE).forEach((key) => {
		if (mergedDefaultValues?.key)
			mergedDefaultValues[key] = { ...mergedDefaultValues[key], ...defaultValuesFromFE[key] };
		else mergedDefaultValues[key] = defaultValuesFromFE[key];
	});
	return mergedDefaultValues;
};
